import _find from 'lodash/find.js';

export const findMultiplier = (skus, itemId) => {
  const stringSku = itemId.toString();
  const match = _find(skus, { sku: stringSku });

  return match ? match.multiplier : 1;
};
